import type { ApiClient } from '@travel/api-client';
import env from '@travel/env';

import type { DisabledComponent } from 'Common-Types';

export const fetchDisabledComponentApi = async (http: ApiClient): Promise<DisabledComponent> => {
  const url = env('UNIVERSAL_DISABLED_COMPONENT_URL');

  return http.get(url as string, {
    ignoreCommonErrorHandler: true,
    isThirdPartyApi: true,
  });
};
